/* Product page behaviors: gallery thumbnails, variant selection, sticky ATC,
   recently-viewed tracking. Works with the markup in sections/main-product.liquid.
   Without JS the page still functions: first available variant is preselected
   in the form and the standard form submit adds to cart. */
(function () {
  'use strict';

  var teardown = null;

  function init() {
    if (teardown) teardown();

    var root = document.querySelector('[data-product-root]');
    if (!root) return;

    // The section embeds product.variants as a JSON array.
    var dataEl = document.querySelector('[data-product-json]');
    var variants = null;
    try {
      variants = dataEl ? JSON.parse(dataEl.textContent) : null;
    } catch (error) {
      variants = null;
    }

    /* ---------- Gallery ---------- */
    var mainImage = root.querySelector('[data-gallery-main] img');

    function showMedia(src, srcset, sizes, alt) {
      if (!mainImage) return;
      mainImage.src = src;
      if (srcset) {
        mainImage.srcset = srcset;
        if (sizes) mainImage.sizes = sizes;
      } else {
        // The main image renders with a srcset; unless it is replaced too, the
        // browser keeps showing the srcset candidate and ignores the new src.
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
      }
      mainImage.alt = alt || '';
    }

    function markCurrentThumb(matcher) {
      var thumbs = root.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', matcher(t) ? 'true' : 'false');
      });
    }

    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb || !mainImage) return;
      showMedia(
        thumb.getAttribute('data-src'),
        thumb.getAttribute('data-srcset'),
        thumb.getAttribute('data-sizes'),
        thumb.getAttribute('data-alt')
      );
      markCurrentThumb(function (t) {
        return t === thumb;
      });
    });

    /* ---------- Variant selection ---------- */
    function moneyFormat(cents) {
      // Uses the shop money format passed on the root element, falling back
      // to a plain dollar rendering. Supports Shopify's amount token variants.
      var format = root.getAttribute('data-money-format') || '${{amount}}';
      var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var token = match ? match[1] : 'amount';
      var value = cents / 100;
      var amount;
      switch (token) {
        case 'amount_no_decimals':
          amount = String(Math.round(value));
          break;
        case 'amount_with_comma_separator':
          amount = value.toFixed(2).replace('.', ',');
          amount = amount.replace(/\B(?=(\d{3})+(?=,))/g, '.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          amount = String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          break;
        case 'amount_with_apostrophe_separator':
          amount = value.toFixed(2).replace(/\B(?=(\d{3})+(?=\.))/g, "'");
          break;
        default:
          amount = value.toFixed(2).replace(/\B(?=(\d{3})+(?=\.))/g, ',');
      }
      return match ? format.replace(match[0], amount) : '$' + amount;
    }

    function currentSelection() {
      var options = [];
      root.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        options[parseInt(fieldset.getAttribute('data-option-index'), 10)] = checked
          ? checked.value
          : null;
      });
      return options;
    }

    function findVariant(options) {
      if (!variants) return null;
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === options[index];
        });
      });
    }

    function announce(message) {
      var region = root.querySelector('[data-variant-status]');
      if (region) region.textContent = message;
    }

    function updateVariantUI(variant, userInitiated) {
      var idInput = root.querySelector('form[data-product-form] input[name="id"]');
      // The sticky bar lives outside [data-product-root]; query the document so
      // its button and price stay in sync with the selected variant.
      var atcButtons = document.querySelectorAll('[data-add-to-cart]');
      var priceTargets = document.querySelectorAll('[data-price]');
      var compareTargets = document.querySelectorAll('[data-compare-price]');
      var stockTarget = root.querySelector('[data-stock-status]');

      if (!variant) {
        atcButtons.forEach(function (btn) {
          btn.disabled = true;
          btn.textContent = btn.getAttribute('data-label-unavailable');
        });
        // Don't leave the previous variant's price/stock next to "Unavailable".
        priceTargets.forEach(function (el) {
          el.textContent = '—';
        });
        compareTargets.forEach(function (el) {
          el.hidden = true;
        });
        if (stockTarget) {
          stockTarget.classList.add('stock-status--out');
          stockTarget.textContent = stockTarget.getAttribute('data-label-unavailable');
        }
        if (userInitiated) {
          announce(stockTarget ? stockTarget.getAttribute('data-label-unavailable') : '');
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      priceTargets.forEach(function (el) {
        el.textContent = moneyFormat(variant.price);
      });

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareTargets.forEach(function (el) {
        el.hidden = !onSale;
        if (onSale) {
          var amountEl = el.querySelector('[data-compare-amount]');
          if (amountEl) amountEl.textContent = moneyFormat(variant.compare_at_price);
        }
      });

      atcButtons.forEach(function (btn) {
        if (variant.available) {
          btn.disabled = false;
          btn.textContent = btn.getAttribute('data-label-add');
        } else {
          btn.disabled = true;
          btn.textContent = btn.getAttribute('data-label-sold-out');
        }
      });

      var stockLabel = '';
      if (stockTarget) {
        stockTarget.classList.toggle('stock-status--out', !variant.available);
        stockLabel = variant.available
          ? stockTarget.getAttribute('data-label-in-stock')
          : stockTarget.getAttribute('data-label-sold-out');
        stockTarget.textContent = stockLabel;
      }

      if (userInitiated) {
        announce(moneyFormat(variant.price) + (stockLabel ? ', ' + stockLabel : ''));
      }

      if (variant.featured_media && variant.featured_media.preview_image && mainImage) {
        var src = variant.featured_media.preview_image.src;
        src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=1100';
        var mediaId = String(variant.featured_media.id);
        var matching = root.querySelector('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
        showMedia(
          src,
          matching && matching.getAttribute('data-srcset'),
          matching && matching.getAttribute('data-sizes'),
          (matching && matching.getAttribute('data-alt')) || variant.featured_media.alt || root.getAttribute('data-product-title')
        );
        markCurrentThumb(function (t) {
          return t.getAttribute('data-media-id') === mediaId;
        });
      }

      if (userInitiated && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (event) {
      if (!event.target.closest('[data-option-index]')) return;
      updateVariantUI(findVariant(currentSelection()), true);
    });

    // Sync UI with the preselected variant on load (covers ?variant= deep
    // links, where the server renders the product-level featured image).
    if (root.querySelector('[data-option-index]')) {
      updateVariantUI(findVariant(currentSelection()), false);
    }

    /* ---------- Sticky add-to-cart (mobile) ---------- */
    var sticky = document.querySelector('[data-sticky-atc]');
    var buyBox = root.querySelector('[data-buy-buttons]');
    var observer = null;
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              sticky.removeAttribute('data-visible');
              document.body.classList.remove('has-sticky-atc');
            } else if (entry.boundingClientRect.top < 0) {
              sticky.setAttribute('data-visible', '');
              document.body.classList.add('has-sticky-atc');
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(buyBox);

      var stickyButton = sticky.querySelector('[data-sticky-submit]');
      if (stickyButton) {
        stickyButton.addEventListener('click', function () {
          var form = root.querySelector('form[data-product-form]');
          if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }
    }

    teardown = function () {
      if (observer) observer.disconnect();
      document.body.classList.remove('has-sticky-atc');
      teardown = null;
    };

    /* ---------- Recently viewed (localStorage only, no tracking) ---------- */
    try {
      var entry = {
        handle: root.getAttribute('data-product-handle'),
        title: root.getAttribute('data-product-title'),
        url: root.getAttribute('data-product-url'),
        image: root.getAttribute('data-product-image'),
        price: root.getAttribute('data-product-price')
      };
      if (entry.handle) {
        var key = 'recently-viewed';
        var list = JSON.parse(window.localStorage.getItem(key) || '[]');
        list = list.filter(function (item) {
          return item.handle !== entry.handle;
        });
        list.unshift(entry);
        window.localStorage.setItem(key, JSON.stringify(list.slice(0, 8)));
      }
    } catch (error) {
      /* localStorage unavailable — feature silently off */
    }
  }

  init();

  // Keep gallery/variant behavior alive when the merchant re-renders the
  // section in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-product-root]')) init();
  });
})();
